import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LegalBasis3BasicRolandDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  return schemaUtils.bornOnErrorMap(issue) ?? { message: ctx.defaultError }
}

const legal_birthday = (params: StepConfigParams) =>
  ({
    schema: z.object({
      born_on: BaseSchema_LegalBasis3BasicRolandDe.shape.born_on,
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.birthday.title',
        },
      },
      {
        type: 'date',
        shouldTrackValues: true,
        name: 'born_on',
        disabledIfValueExists: true,
      },
    ],
    nextStep: 'legal_zip',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default legal_birthday
